import { createSlice } from '@reduxjs/toolkit';
import { getAllUsers } from './thunks';

// Initial state for Redux store:
export const initialStateUsers = {
  users: {
    total: 0,
    users: [],
    paginate: {
      current_page: 1,
      items: 0,
      pages: 1,
    },
    success: false,
  },
  loading: false,
};

const usersSlice = createSlice({
  name: 'users',
  initialState: initialStateUsers, // Define initial state
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getAllUsers.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(getAllUsers.fulfilled, (state, action) => {
      state.users = action.payload;
      state.loading = false;
    });
  },
});

// Export reducer generated by "createSlice()":
export default usersSlice.reducer;
